import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  toggle() {
    const type = this.inputTarget.getAttribute('type') === 'password' ? 'text' : 'password'
    this.inputTarget.setAttribute('type', type)

    this.iconTarget.classList.toggle('bi-eye')
    this.iconTarget.classList.toggle('bi-eye-slash')
  }
}
